import type { BannerItem as HomeSliderType } from '@/types'
import Link from 'next/link'
import { useRef, type FC } from 'react'
import type { Settings } from 'react-slick'
import Slider from 'react-slick'
import ImageOptimize from '../ImageOptimize'

interface Props {
  sliders: Array<HomeSliderType>
}

export const HomeSlider: FC<Props> = ({ sliders }: Props) => {
  const sliderSettings: Settings = {
    autoplay: true,
    dots: false,
    autoplaySpeed: 10000,
    arrows: false,
    fade: true,
    speed: 500,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
  }
  const ref = useRef<Slider>(null)

  return (
    <section
      className={`homeSlider overflow-hidden w-full relative top-[-1px] ${
        !sliders ? 'hidden' : ''
      }`}
    >
      {sliders ? (
        <Slider
          ref={ref}
          {...sliderSettings}
          className='max-w-screen slickHome flex'
        >
          {sliders &&
            sliders.map((slider: HomeSliderType, index: number) => (
              <Link href={slider?.link || '/'} key={index}>
                <ImageOptimize
                  className='w-full h-auto'
                  src={slider?.image}
                  alt={slider?.title}
                  // width/height chỉ dùng để giữ chỗ trước khi ảnh tải (ảnh vẫn
                  // hiển thị theo tỉ lệ thật: w-full h-auto). 1312x480 (tỉ lệ 0.366)
                  // lệch với banner thật tỉ lệ 0.624 (3900x2434, 1563x975, 1125x702, 750x468) đo trên prod -> slider
                  // giãn 151px -> 257-290px khi ảnh tải xong, đẩy cả trang (CLS).
                  width={1312}
                  height={819}
                  // Chỉ slide đầu preload + fetchpriority high (ứng viên LCP); các slide
                  // ẩn đặt low để không tranh băng thông với slide đầu.
                  priority={index === 0}
                  fetchPriority={index === 0 ? 'high' : 'low'}
                  lazyLoad={false}
                />
              </Link>
            ))}
        </Slider>
      ) : (
        ''
      )}
    </section>
  )
}
